export const PERMISSIONS = "PERMISSIONS";
export const PERMISSION_SUCCESS = "PERMISSION_SUCCESS";
export const PERMISSION_ERROR = "PERMISSION_ERROR";